/* GET /api/events (SSE) — общий живой канал платформы, одна вкладка = один поток;
   уведомления, счётчики, состояния продуктов и обновление Оболочки приходят одним кадром
   общей формы Frame, не отдельными каналами. */
import { sharedEventBus } from "../osnovaContext";
import { isFrame } from "./frame";
const LIVE_URL = "/api/events";
const MAX_CONSECUTIVE_ERRORS = 6;
const RECONNECT_MIN_DELAY_MS = 5000;
const RECONNECT_MAX_DELAY_MS = 30000;
// Событие "живого кадра" — любой потребитель шапки/рельсы подписывается на него, не заводя
// свой EventSource (одна вкладка = один поток /api/events).
export const LIVE_FRAME_EVENT = "live:frame";
// Событие смены статуса связи — деградация должна быть честной, не молчаливой.
export const LIVE_STATUS_EVENT = "live:status";
// Событие "нужен ресинк снимком" — на open потока: живая доставка best-effort, БД —
// источник истины; подписчик обязан перечитать свои GET-снимки сам, live не читает их за
// него (live не знает про /api/products и /api/notifications).
export const LIVE_RESYNC_EVENT = "live:resync";
// startLiveStream открывает единственный SSE-поток вкладки и рассылает кадры через
// sharedEventBus. Возвращает функцию остановки — обязательна к вызову при размонтировании.
export function startLiveStream() {
    let es = null;
    let consecutiveErrors = 0;
    let reconnectDelay = RECONNECT_MIN_DELAY_MS;
    let reconnectTimer = null;
    let stopped = false;
    const clearReconnectTimer = () => {
        if (reconnectTimer !== null) {
            clearTimeout(reconnectTimer);
            reconnectTimer = null;
        }
    };
    const scheduleReconnect = () => {
        if (stopped)
            return;
        clearReconnectTimer();
        reconnectTimer = setTimeout(() => {
            reconnectTimer = null;
            connect();
        }, reconnectDelay);
        reconnectDelay = Math.min(reconnectDelay * 2, RECONNECT_MAX_DELAY_MS);
    };
    const connect = () => {
        if (stopped)
            return;
        es = new EventSource(LIVE_URL, { withCredentials: true });
        es.onopen = () => {
            consecutiveErrors = 0;
            reconnectDelay = RECONNECT_MIN_DELAY_MS;
            sharedEventBus.emit(LIVE_STATUS_EVENT, { connected: true });
            sharedEventBus.emit(LIVE_RESYNC_EVENT, {});
        };
        es.onmessage = (e) => {
            let parsed;
            try {
                parsed = JSON.parse(e.data);
            }
            catch {
                return; // повреждённый кадр — игнорируем
            }
            if (!isFrame(parsed))
                return;
            const frame = parsed;
            sharedEventBus.emit(LIVE_FRAME_EVENT, frame);
            sharedEventBus.emit(`${LIVE_FRAME_EVENT}:${frame.type}`, frame);
        };
        // Браузер сам переподключает EventSource на кратких обрывах; честный признак «нет связи»
        // зажигается только после MAX_CONSECUTIVE_ERRORS подряд, и только тогда мы берём
        // переподключение на себя (backoff), чтобы не долбить упавший бэкенд каждую секунду.
        es.onerror = () => {
            if (stopped)
                return;
            consecutiveErrors += 1;
            if (consecutiveErrors >= MAX_CONSECUTIVE_ERRORS) {
                es?.close();
                sharedEventBus.emit(LIVE_STATUS_EVENT, { connected: false });
                scheduleReconnect();
            }
        };
    };
    connect();
    return () => {
        stopped = true;
        clearReconnectTimer();
        es?.close();
    };
}
